module.exports = __webpack_public_path__ + "static/media/skin-banner-img.e77305dd.png";